import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { throwError } from 'rxjs';
import { ConnectivityService } from '../connectivity';
import { OfflineError } from '../connectivity/offline.error';

/**
 * Requests for bundled assets (the translations, the country and state lists, ...). They are served
 * locally, so they do not need connectivity: blocking them would leave the app without its texts (and
 * without its selectors) while offline.
 */
const LOCAL_ASSET_PATTERN = /(^|\/)assets\//;

/**
 * @description
 * Prevents any backend request from being sent while there is no connectivity.
 *
 * IMPORTANT: it must be registered BEFORE `apiInterceptor`. If it ran after,
 * `apiInterceptor` would catch the offline error and treat it as an auth or
 * unexpected error (refreshing the token, redirecting to `/login` or `/error`).
 */
export const offlineInterceptor: HttpInterceptorFn = (req, next) => {
  const connectivity = inject(ConnectivityService);

  if (LOCAL_ASSET_PATTERN.test(req.url)) {
    return next(req);
  }

  if (connectivity.isOffline()) {
    return throwError(() => new OfflineError(`Request to "${req.url}" was not sent to the backend.`));
  }

  return next(req);
};
